
const PlayBeepSound = () => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    // Set up oscillator type and frequency
    oscillator.type = "square"; // Other options: 'square', 'sawtooth', 'triangle'
    oscillator.frequency.setValueAtTime(440, audioContext.currentTime); // 440 Hz is a standard A note

    // Connect oscillator to gain node and audio context destination
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    // Play the beep for a short duration
    oscillator.start();
    setTimeout(() => {
      oscillator.stop();
      audioContext.close();
    }, 500); // 200ms beep
  };

  export default PlayBeepSound;